export var PickItemStatus;
(function (PickItemStatus) {
    PickItemStatus[PickItemStatus["ENTERED"] = 1] = "ENTERED";
    PickItemStatus[PickItemStatus["SHORT"] = 2] = "SHORT";
    PickItemStatus[PickItemStatus["FINISHED"] = 3] = "FINISHED";
})(PickItemStatus || (PickItemStatus = {}));
//# sourceMappingURL=pick-item-status.js.map